/* src/app/components/pages/login/login.component.scss */
.seprator {
  border-right: 1px solid #cfcfcf;
}
.btn-color {
  background-color: var(--theme-deafult-secondary);
}
.head-text {
  border-bottom: 1px solid #cfcfcf;
  padding: 2%;
}
.p-50 {
  padding: 50px;
}
.txt-center {
  text-align: center;
}
#autologin {
  margin-left: 23%;
  margin-right: 25%;
  background: #fff;
}
.autologin {
  padding: 45px 0 45px;
  font-size: 25px;
}
@media (min-width: 1440px) {
  .login {
    max-width: 1365px;
    margin: auto;
  }
}
.btn-width {
  min-width: 150px !important;
}
.login .btn-border {
  border: 1px solid black;
}
.login .vertical-divider {
  border-top-width: 0;
  border-right-width: 1px;
  border-right-style: solid;
  height: 100%;
}
.login .upper-case {
  text-transform: uppercase !important;
}
.login .isIpadView {
  display: none;
}
@media only screen and (max-width: 768px) and (min-width: 767px) {
  .login .isIpadView {
    display: block;
    border-left: 1px solid rgba(0, 0, 0, 0.12);
    height: 150PX;
  }
  .login .isIpad {
    margin-right: 10px;
  }
}
@media screen and (max-width: 599px) {
  .login .login-bottom {
    align-content: center;
  }
  .login .login-bottom button {
    width: 100%;
  }
  .login .login-bottom .donot_have_account,
  .login .login-bottom .already_have_account {
    margin: 5px auto;
  }
  .login .login-bottom #create-one,
  .login .login-bottom .signIn_account {
    margin: auto;
  }
  .login .md-content_Login_or {
    padding: 0;
  }
}
.login .has-error .help-block {
  top: 52px !important;
}
.login ::ng-deep .mat-mdc-form-field {
  --mat-form-field-outlined-container-shape: 28px;
}
.login .w-70 {
  width: 70%;
}
.login mat-form-field input {
  margin: 0 0 6px 14px;
}
/*# sourceMappingURL=login.component.css.map */
